import type { LeadFlowDocument, LeadFlowStepErrors } from "../types";

/**
 * Stable empty values, so a flow without steps or a step without errors
 * keeps the same reference across renders and memoized consumers don't
 * re-run.
 */
const NO_ERRORS: LeadFlowStepErrors = Object.freeze({});
const NO_STEPS: NonNullable<LeadFlowDocument["steps"]> = [];

export { NO_ERRORS, NO_STEPS };
